import React from "react";
import CurrencyText from "./CurrencyText";
import "./CurrencyText.css";

interface myComponentProps {
  curOne?: string;
  curTwo?: string;
  urlOne?: string;
  urlTwo?: string;
  loading?: boolean;
}

const ExchangeCurrencyText = ({
  curOne,
  curTwo,
  urlOne,
  urlTwo,
  loading,
}: myComponentProps) => {
  return (
    <div className="exchange-rate-box-fragment-reusable-comp">
      <CurrencyText
        loading={loading}
        text={curOne}
        url={urlOne}
        currency={curOne}
      />
      <div className="dash"></div>
      <CurrencyText
        loading={loading}
        text={curTwo}
        url={urlTwo}
        currency={curTwo}
      />
    </div>
  );
};

export default ExchangeCurrencyText;
